export function minLength(value, min = 5) {
  return typeof value === "string" && value.trim().length >= min;
}
